<div class="edit-seats-object">
  <div class="options-edit-section active">
    <div class="section-edit">
      <p class="panel-group__title m-0">Curvar selección</p>

      <div class="field-group">
        <label class="field-label">Tipo de curva</label>
        <div class="curvature-mode-toggle d-flex" style="gap:8px">
          <button type="button" class="btn-mode" [class.active]="mode==='circular'"
            (click)="setMode('circular')">Circular</button>
          <button type="button" class="btn-mode" [class.active]="mode==='elliptical'"
            (click)="setMode('elliptical')">Elíptica</button>
          <button type="button" class="btn-mode" [class.active]="mode==='parabolic'"
            (click)="setMode('parabolic')">Parábola</button>
        </div>
      </div>

      <ng-container *ngIf="mode==='circular' || mode==='elliptical'">
        <div class="field-group">
          <label class="field-label">Centro de curvatura</label>
          <div class="pivot-controls d-flex align-items-center" style="gap:8px">
            <button type="button" class="btn-pivot" [class.active]="placingCenter"
              (click)="togglePlacingCenter.emit()">
              <i class="fa-light" [class.fa-crosshairs]="!placingCenter" [class.fa-check]="placingCenter"></i>
              {{ placingCenter ? 'Colocando…' : 'Mover centro' }}
            </button>
          </div>
          <p class="info-hint" *ngIf="placingCenter">
            Arrastra el punto ✛ sobre el mapa para ajustar el centro y el radio del arco.
          </p>
        </div>

        <div class="field-range">
          <div class="field-range__head">
            <label class="field-label">Radio</label>
            <span class="field-range__value">
              <input type="number" min="0" step="10" [ngModel]="radius" (ngModelChange)="radiusChange.emit($event)">
            </span>
          </div>
          <input type="range" min="10" max="4000" step="10" [ngModel]="radius"
            (ngModelChange)="radiusChange.emit($event)" class="slider-rotation">
        </div>

        <div class="field-range">
          <div class="field-range__head">
            <label class="field-label">Amplitud del arco</label>
            <span class="field-range__value">
              <input type="number" min="1" max="359" step="1" [ngModel]="arcDeg" (ngModelChange)="arcDegChange.emit($event)">
              <span class="field-range__unit">°</span>
            </span>
          </div>
          <input type="range" min="1" max="359" step="1" [ngModel]="arcDeg"
            (ngModelChange)="arcDegChange.emit($event)" class="slider-rotation">
        </div>

        <ng-container *ngIf="mode==='elliptical'">
          <div class="field-range">
            <div class="field-range__head">
              <label class="field-label">Achatamiento (eje Y / eje X)</label>
              <span class="field-range__value">
                <input type="number" min="0.1" max="1" step="0.05" [ngModel]="ellipseAspect"
                  (ngModelChange)="ellipseAspectChange.emit($event)">
              </span>
            </div>
            <input type="range" min="0.1" max="1" step="0.05" [ngModel]="ellipseAspect"
              (ngModelChange)="ellipseAspectChange.emit($event)" class="slider-rotation">
            <p class="info-hint">1 = círculo perfecto. Cuanto menor, más ovalada.</p>
          </div>
          <div class="field-range">
            <div class="field-range__head">
              <label class="field-label">Rotación del óvalo</label>
              <span class="field-range__value">
                <input type="number" min="-180" max="180" step="1" [ngModel]="ellipseRotation"
                  (ngModelChange)="ellipseRotationChange.emit($event)">
                <span class="field-range__unit">°</span>
              </span>
            </div>
            <input type="range" min="-180" max="180" step="1" [ngModel]="ellipseRotation"
              (ngModelChange)="ellipseRotationChange.emit($event)" class="slider-rotation">
          </div>
        </ng-container>
      </ng-container>

      <div class="field-range" *ngIf="mode==='parabolic'">
        <div class="field-range__head">
          <label class="field-label">Curvatura</label>
          <span class="field-range__value">
            <input type="number" min="-3" max="3" step="0.1" [ngModel]="curvature" (ngModelChange)="curvatureChange.emit($event)">
          </span>
        </div>
        <input type="range" min="-3" max="3" step="0.1" [ngModel]="curvature"
          (ngModelChange)="curvatureChange.emit($event)" class="slider-rotation">
      </div>

      <div class="field-group">
        <label class="checkbox-inline">
          <input type="checkbox" [checked]="invert" (change)="invertChange.emit()">
          Invertir orden
        </label>
      </div>

      <div class="btns-save-apply">
        <button type="button" class="btn-map-action" (click)="cancel.emit()">
          <i class="fa-regular fa-xmark"></i> Cancelar
        </button>
        <button type="button" class="btn-map-action" (click)="apply.emit()">
          <i class="fa-regular fa-check"></i> Aplicar
        </button>
      </div>
    </div>
  </div>
</div>
